import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CourseDetailHaveCourseTagStyle = styled(Box)`
  width: 140px;
  height: 30px;
  border-radius: 24px;
  background-color: #4caf50;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;

  .check-circle-outline-icon {
    width: 14.67px;
    height: 14.67px;
    color: #ffffff;
  }
  .text {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    margin-left: 3px;
  }

  @media only screen and (max-width: 767px) {
    width: 134px;
    height: 18px;
    padding: 11px;

    .check-circle-outline-icon {
      width: 12px;
      height: 12px;
    }

    .text {
      font-size: 14px;
    }
  }
`;
